<template>
  <div>
    <Modal v-model="modal" :width="modalWidth" class-name="export-modal" :closable="false" :mask-closable="false">
      <div class="flow-modal-title" slot="header">
        <span style="font-size: 17px">{{title}}</span>
        <span @click="closeModal()" style="position: absolute; right: 6px;cursor: pointer;">
          <i class="ivu-icon ivu-icon-ios-close"></i>
        </span>
      </div>
      <div class="exporttask">
        <!-- <s-DataGrid   funcMark="bsp:model:exporttask" :params="gridRequestParams" ></s-DataGrid> -->
         <s-TableGrid  funcMark="bsp:model:exporttask" :params="gridRequestParams" ></s-TableGrid>
      </div>
      <div slot="footer" class="model-footer"></div>
    </Modal>
  </div>
</template>

<script>
import Qs from 'qs'
// import { sDataGrid } from  'sd-data-grid'  //'@/components/data-grid' 
import { sTableGrid } from  'sd-table-grid'
export default {
  name: 'grid-data-opt',
  components: {
      sTableGrid
    },
  
  props: {
    modalWidth: {
      type: Number,
      default: 900
    },
    modalHeight: {
      type: Number,
      default: 600
    },
    gridAllShowFields: {
      type: Array,
      default() {
        return []
      }
    },
    selectedRows: {
      type: Array,
      default() {
        return []
      }
    },
    modelId: {
      type: String,
      default: ''
    },
    rowMark: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number,
      default: 10
    },
    gridRequestParams: {
      type: Object,
      default() {
        return null
      }
    },
    exportMaxCount: {
      type: Number,
      default: 2000
    },
    exportOption: {
      type: Object,
      default() {
        return {
          fileType: '0',
          exportFields: [],
          pageRange: {
            fromPageNo: 1,
            toPageNo: 1
          }
        }
      }
    }
  },
  data() {
    return {
      modal: true,
      title: '导出数据下载',
      totalCount: 0,
      modal_loading: false,
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {

    closeModal() {
      this.modal = false
      this.$emit('closeModal')
    },
    
  }
}
</script>

<style lang="less" scoped>
/deep/ .export-modal .ivu-modal-body,
/deep/ .export-modal .ivu-modal-header {
  padding: 0 !important;
}
/deep/ .ivu-tag-text{
  color: #fff!important;
}
/deep/ .ivu-modal-body {
  max-height: 440px;
  overflow-y: auto;
}
/deep/ .export-modal .ivu-modal-footer {
  padding: 8px 18px 8px 18px;
}
/deep/ .export-modal .ivu-icon-ios-close {
  font-size: 32px;
  line-height: 40px;
}
/deep/ .export-modal .ivu-modal-footer {
  background: #f7faff;
  border-color: #cee0f0;
}

/* 自定义弹窗底部按钮样式重置 */
.export-modal .model-footer /deep/ .ivu-btn-primary {
  font-size: 16px;
  min-width: 80px;
  height: 36px;
  opacity: 1;
  background: #2b5fd9;
  border-radius: 2px;
  margin: 0 8px;
}
.export-modal .flow-modal-title {
  height: 40px;
  background: #2b5fda;
  width: 100%;
  text-indent: 1em;
  color: #fff;
  line-height: 40px;
}
.export-modal .model-footer button {
  font-size: 16px;
  min-width: 80px;
  height: 36px;
  opacity: 1;
  border-radius: 2px;
  margin: 0 8px;
}

.exporttask{
  margin:16px ;
}

/deep/ .ivu-checkbox-group-item {
  width: 160px;
  font-size: 16px;
}

/deep/ .ivu-form .ivu-form-item-label {
  font-size: 16px;
}

/deep/ .ivu-form-item-content {
  font-size: 16px;
}

  /deep/ .export-modal *::-webkit-scrollbar {
    width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
  }

  /deep/ .export-modal *::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #b7c7dd;
  }

  /deep/ .export-modal *::-webkit-scrollbar-track {
    border-radius: 3px;
    background: #EDEDED;
  }
</style>


// WEBPACK FOOTER //
// src/component/data-grid/components/grid-data-opt.vue